
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-05-25-r3f-view-tracking",
      function () {
        return require("private-next-pages/blogs/2025-05-25-r3f-view-tracking/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-05-25-r3f-view-tracking"])
      });
    }
  